import createHash from 'create-hash';
import apiService, { defaultHeaders } from 'services/apiService';

export function getZoneId (feature) {
  const { geometry: { coordinates } } = feature;
  const rawId = JSON.stringify(coordinates);
  const hash = createHash('sha1');
  hash.update(rawId);
  return hash.digest('hex');
}

export async function fetchZones () {
  try {
    const { data: { geojson_url: geojsonUrl } } = await apiService.request('/layer/triages/', {
      headers: defaultHeaders,
    });
    const { data } = await apiService.request(geojsonUrl.replace(/^\/api/, ''), {
      headers: defaultHeaders,
    });
    data.features = data.features.map(feature => ({
      ...feature,
      properties: {
        ...feature.properties,
        tmpId: getZoneId(feature),
      },
    }));
    return data;
  } catch (error) {
    return null;
  }
}

export async function saveZones (features) {
  const featuresToSend = (!Array.isArray(features)
    ? [features]
    : features
  ).map(feature => {
    const { properties: { tmpId, ...properties } } = feature;
    return {
      ...feature,
      properties: {
        ...properties,
      },
    };
  });

  try {
    return apiService.request('/layer/triages/', {
      headers: defaultHeaders,
      method: 'PATCH',
      body: JSON.stringify({ features: featuresToSend }),
    });
  } catch (error) {
    return null;
  }
}

export function getCenter (features) {
  const longLats = features.reduce((all1, feature) =>
    all1.concat(feature.geometry.coordinates.reduce((all2, coordinate) =>
      all2.concat(coordinate.reduce((all3, coord) =>
        all3.concat(Array.isArray(coord[0])
          ? coord.reduce((all4, longLat) => (
            Array.isArray(longLat)
              ? [...all4, longLat]
              : all4
          ), [])
          : [coord]), [])), [])), []);

  const maxCoord = longLats.reduce((prev, [long, lat]) => ({
    latMax: Math.max(lat, prev.latMax),
    latMin: Math.min(lat, prev.latMin),
    longMax: Math.max(long, prev.longMax),
    longMin: Math.min(long, prev.longMin),
  }), {
    latMax: -Infinity,
    latMin: +Infinity,
    longMax: -Infinity,
    longMin: +Infinity,
  });

  return [
    maxCoord.longMin + ((maxCoord.longMax - maxCoord.longMin) / 2),
    maxCoord.latMin + ((maxCoord.latMax - maxCoord.latMin) / 2),
  ];
}

export default fetchZones;



// WEBPACK FOOTER //
// ./src/helpers/zonesHelpers.js